var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('section',{staticClass:"cover"},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"heading"},[_vm._v("Redirecting to Microsoft Login Api......")]),_vm._v(" "),_c('div',{staticClass:"cta-btn"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb67431","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/pages/Login.vue
// module id = 498
// module chunks = 0